import type {TriggerIntegration} from '@cohort/merchants/apps';
import CohortFormTriggerIntegrationActionCtaComponentPreview from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/ActionCtaComponentPreview';
import StepCompletionContextComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/StepCompletionContextComponent';
import StepCompletionsGridComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/StepCompletionsGridComponent';
import StepCompletionTitleComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/StepCompletionTitleComponent';
import useStepCompletionColumns from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/useStepCompletionColumns';
import CohortFormLongTextTriggerConfigComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/longText/ConfigComponent';
import CohortFormLongTextTriggerIntegrationComponentPreview from '@cohort/merchants/apps/cohort-form/triggerIntegrations/longText/TriggerComponentPreview';
import type {CohortFormLongTextTriggerStruct} from '@cohort/shared/apps/cohort-form/triggers/longText';
import {CohortFormLongTextTriggerIntegrationSpec} from '@cohort/shared/apps/cohort-form/triggers/longText';

export const CohortFormLongTextTriggerIntegration: TriggerIntegration<CohortFormLongTextTriggerStruct> =
  {
    spec: CohortFormLongTextTriggerIntegrationSpec,
    configComponent: CohortFormLongTextTriggerConfigComponent,
    stepCompletionTitleComponent: StepCompletionTitleComponent,
    stepCompletionContextComponent: StepCompletionContextComponent,
    useStepCompletionColumns: useStepCompletionColumns,
    stepCompletionsGridComponent: StepCompletionsGridComponent,
    getTitle: t => t('triggerIntegrations.long-text.title', {ns: 'app-cohort-form'}),
    preview: {
      CtaComponent: CohortFormTriggerIntegrationActionCtaComponentPreview,
      TriggerComponent: CohortFormLongTextTriggerIntegrationComponentPreview,
    },
  };
